import { AffectationType, InitialValuesAffectation } from 'components/types';
import axiosInstance from 'utils/axiosInstance';

export const GetAffectation = async (
  url: string,
  filters: InitialValuesAffectation,
) => {
  const { data } = await axiosInstance.post<ApiResponse<AffectationType>>(
    url,
    filters,
  );
  return data.data ?? data;
};

export const AssignedSiteService = async (
  url: string,
  credential: InitialValuesAffectation,
) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(url, credential);
  return data;
};
